<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="邀标编号:" prop="flowNo">
              <el-input  placeholder="" v-model="searchFrom.flowNo"></el-input>
            </el-form-item>
             <el-form-item label="船舶流向:" prop="shipFlowName">
                <el-select  v-model="searchFrom.shipFlowName"   placeholder="请选择">
                  <el-option v-for="item in LXList" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态:" prop="status">
                <el-select  v-model="searchFrom.status"   placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="待报价" value="1001"></el-option>
                  <el-option label="报价中" value="1101"></el-option>
                  <el-option label="已结束" value="1201"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="港口:" prop="addressName">
              <el-input  placeholder="" v-model="searchFrom.addressName"></el-input>
            </el-form-item>
            <el-form-item label="受载时间:" prop="loadTime">
                <el-date-picker
                  v-model="searchFrom.loadTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="计价方式:" prop="pricingMethod">
                <el-select  v-model="searchFrom.pricingMethod"   placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="按吨" value="1"></el-option>
                  <el-option label="包船" value="2"></el-option>
                </el-select>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
         <el-form-item  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item v-if="btnFlg[1]">
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item   v-if="btnFlg[2]" >
            <el-button type="primary"  @click="addRegion">新增</el-button>
          </el-form-item>
          <el-form-item   v-if="btnFlg[7]" >
            <el-button type="primary"  @click="chongXinFaBu">重新发布</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="160">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini"  v-if="btnFlg[3]&&scope.row.status==1001"   @click="editFn(scope.row)">修改</el-button>
                <el-button type="text" size="mini"  v-if="btnFlg[4]&&scope.row.status==1001"   @click="delFn(scope.row)">删除</el-button>
                <el-button type="text" size="mini"  v-if="btnFlg[5]&&scope.row.status!=1201"   @click="jiesuFN(scope.row)">报价结束</el-button>
                <el-button type="text" size="mini"  v-if="btnFlg[6]&&scope.row.status!=1001"   @click="lookFn(scope.row)">查看报价</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="flowNo" min-width="200"  :formatter="emptyFn" label="邀标编号"></el-table-column>
        <el-table-column property="status" label="状态" :formatter="statusFormat"></el-table-column>
         <el-table-column property="pricingMethod" width="110" label="计价方式" >
          <template scope="scope">
            {{[ "按吨", "包船" ][scope.row.pricingMethod-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="shipFlowName"  min-width="200" :formatter="emptyFn" label="船舶流向"></el-table-column>
        <el-table-column prop="loadTime" width="170" :formatter="dateFormat"  label="受载时间"></el-table-column>
        <el-table-column prop="productTypeName"  min-width="200" :formatter="emptyFn" label="货物类型"></el-table-column>
        <el-table-column prop="referenceCapacity" width="120" :formatter="emptyFn" label="船舶载重(吨)"></el-table-column>
        <el-table-column prop="deliverAddressName" width="300" :formatter="emptyFn" label="起始港口"></el-table-column>
        <el-table-column prop="receivingAddressName" width="300" :formatter="emptyFn" label="目的港口"></el-table-column>
        <el-table-column prop="remark" :show-overflow-tooltip="true"  min-width="200" :formatter="emptyFn" label="备注"></el-table-column>
        <el-table-column prop="createUserName" width="150" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog  :title="isAdd?'添加':'修改'"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="700px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="130px" size="mini">
        <div class="inpBox">
            <div>
              <el-form-item label="计价方式:" prop="pricingMethod" class="jiage">
                  <el-radio-group v-model="addFrom.pricingMethod" >
                    <el-radio :label="1">按吨</el-radio>
                    <el-radio :label="2">包船</el-radio>
                  </el-radio-group>
              </el-form-item>
            </div>
              <el-form-item label="船舶流向:" prop="shipFlow">
                <el-select  v-model="addFrom.shipFlow"  value-key="id"  placeholder="请选择" filterable>
                  <el-option v-for="item in LXList" :label="item.showName" :value="item" :key="item.id"></el-option>
                 </el-select>
              </el-form-item>
              <el-form-item label="受载时间:" prop="loadTime" >
                <el-date-picker
                    v-model="addFrom.loadTime"
                    format="yyyy-MM-dd"
                    value-format="timestamp"
                    type="date"
                    :picker-options="pickerOptions"
                      placeholder="选择日期时间"
                  ></el-date-picker>
                </el-form-item>
              <el-form-item label="货物类型:"  prop="productTypeId" class="hwlx">
                <el-select  v-model="addFrom.productTypeId" multiple    placeholder="请选择" >
                  <el-option v-for="item in productTypes" :label="item.name" :value="item.productId" :key="item.productId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="船舶载重:" prop="referenceCapacity" class="jiage">
                <el-input  placeholder=""  v-number-input.float="0"  maxlength="8" v-model="addFrom.referenceCapacity"  ></el-input><span class="danwei1">吨</span>
              </el-form-item>
              <el-form-item label="起始港口:" prop="deliverAddressId" class="jiage">
              <el-select v-model="addFrom.deliverAddressId" placeholder="请选择" filterable @change="qishiChange">
                <el-option v-for="(item) in MTList" :label="item.addressName" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="jiage" v-for="(domain, index) in addFrom.mudigang" :label="'目的港口' +(index-0+1)" :key="domain.key" :prop="'mudigang.' + index + '.id'" :rules="{required: true, message: '目的港口不能为空', trigger: 'blur' }">
              <el-select v-model="domain.id" value-key="id" placeholder="请选择" filterable @change="mudiChange($event,index)">
                <el-option v-for="(item) in MTList" :label="item.addressName" :value="item.id" :key="item.id"></el-option>
              </el-select>
              <div class="iconBox" v-if="index==0" @click="addMudidi"><i class="el-icon-circle-plus-outline"></i></div>
              <div class="iconBox" v-else @click="delMudidi(index)"><i class="el-icon-delete"></i></div>
            </el-form-item>
           <el-form-item label="备注:" class="remark" prop="remark" >
              <el-input  placeholder="" type="textarea" rows="3"  maxlength="100" v-model="addFrom.remark"></el-input>
            </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { sAddressList, sShipFlowList, sShipFlowAdd, sShipFlowDelete, sShipDictionaryList, sShipFlowUpdateFlow, againPublishFlow } from '@/api/shipping'
import { dropDownList } from '@/api/soc-stock'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
export default {
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      dialogVisible: false,
      isAdd: true,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      ids: [],
      loading: 'false',
      rules: {
        shipFlow: [
          { required: true, message: '请选择船舶流向', trigger: 'blur' }
        ],
        loadTime: [
          { required: true, message: '请选择受载时间', trigger: 'blur' }
        ],
        productTypeId: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        referenceCapacity: [
          { required: true, message: '请输入船舶载重', trigger: 'blur' }
        ],
        deliverAddressId: [
          { required: true, message: '请选择起始港口', trigger: 'blur' }
        ]
      },
      addFrom: {
        mudigang: [{ key: 1 }],
        pricingMethod: 1
      },
      MTList: [],
      LXList: [], // 流向
      productTypes: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      btnFlg: [],
      btnIdArr: ['00KM070100', '00KM070200', '00KM070300', '00KM070400', '00KM070500',
        '00KM070600', '00KM070700', '00KM070800']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    sAddressList({ addressType: 2 }).then(res => {
      this.MTList = res
    })
    sShipDictionaryList({ groupNo: 'ship_flow' }).then(res => {
      this.LXList = res
    })
    dropDownList().then(res => {
      this.productTypes = res
    })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 重新发布
    chongXinFaBu () {
      let selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      if (selectData[0].status == 1201) {
        this.$alert('该状态下的数据不能重新发布', '系统提示')
        return
      }
      this.$confirm('是否重新发布?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        againPublishFlow({ id: selectData[0].id }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 报价结束
    jiesuFN (row) {
      this.$confirm('是否要结束报价?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sShipFlowUpdateFlow({ id: row.id, status: 1201 }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查看报价
    lookFn (row) {
      this.$router.push({ path: '/Squotation/lookQuotation', query: { id: row.id, jiedanFlag: row.quoteTenantId ? 1 : 2 } })
    },
    // 起始港改变
    qishiChange (e) {
      let flag = this.addFrom.mudigang.some(item => item.id == e)
      if (flag) {
        this.$alert('起始港口与目的港口不能相同', '系统提示')
        this.$set(this.addFrom, 'deliverAddressId', null)
      }
      console.log(this.addFrom.mudigang)
    },
    // 目的港改变
    mudiChange (e, index) {
      if (e == this.addFrom.deliverAddressId) {
        this.$alert('起始港口与目的港口不能相同', '系统提示')
        this.$set(this.addFrom.mudigang, index, { key: this.addFrom.mudigang.length + 1 })
      }

      let flag = this.addFrom.mudigang.some((item, n) => {
        if (index != n) {
          return item.id == e
        }
      })
      if (flag) {
        this.$alert('该目的港口已存在', '系统提示')
        this.$set(this.addFrom.mudigang, index, { key: this.addFrom.mudigang.length + 1 })
      }
    },
    addMudidi () {
      if (this.addFrom.mudigang.length == 5) {
        this.$alert('最多添加5个目的港口', '系统提示')
        return
      }
      this.addFrom.mudigang.push({ key: this.addFrom.mudigang.length + 1 })
    },
    delMudidi (index) {
      this.addFrom.mudigang.splice(index, 1)
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      sShipFlowList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.addFrom = { mudigang: [{ key: 1 }], pricingMethod: 1 }
      this.dialogVisible = true
      this.isAdd = true
    },
    editFn (row) {
      this.$set(this.addFrom, 'pricingMethod', row.pricingMethod)
      this.$set(this.addFrom, 'mudigang', [])
      this.$set(this.addFrom, 'id', row.id)
      this.$set(this.addFrom, 'loadTime', row.loadTime)
      this.$set(this.addFrom, 'deliverAddressId', Number(row.deliverAddressId))
      this.$set(this.addFrom, 'referenceCapacity', row.referenceCapacity)
      this.$set(this.addFrom, 'remark', row.remark)
      this.$set(this.addFrom, 'shipFlow', { showName: row.shipFlowName, id: row.shipFlowId })
      let arr = row.receivingAddressId.split(',')
      arr.forEach((item, index) => {
        this.$set(this.addFrom.mudigang, index, { key: index + 1, id: Number(item) })
      })
      this.$set(this.addFrom, 'productTypeId', row.productTypeId.split(','))
      this.dialogVisible = true
      this.isAdd = false
    },
    saveFn (formName) {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          let arr = []
          this.addFrom.productTypeId.forEach(item => {
            arr.push(this.productTypes.find(item1 => item1.productId === item).name)
          })
          this.addFrom.productTypeName = arr.toString()
          this.addFrom.productTypeId = this.addFrom.productTypeId.toString()
          if (this.addFrom.shipFlow) {
            this.addFrom.shipFlowId = this.addFrom.shipFlow.id
            this.addFrom.shipFlowName = this.addFrom.shipFlow.showName
          }
          if (this.addFrom.deliverAddressId) {
            let json = this.MTList.find(item1 => item1.id == this.addFrom.deliverAddressId)
            this.addFrom.deliverAddress = { addressName: json.addressName, addressId: json.id }
          }
          this.addFrom.receiveAddressList = []
          this.addFrom.mudigang.forEach(item => {
            let json = this.MTList.find(item1 => item1.id == item.id)
            this.addFrom.receiveAddressList.push({ addressName: json.addressName, addressId: json.id })
          })
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            sShipFlowAdd(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                  this.addFrom.productTypeId = this.addFrom.productTypeId.split(',')
                }
              })
            })
          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            sShipFlowUpdateFlow(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                duration: 0,
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sShipFlowDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {
      this.addFrom = { mudigang: [{ key: 1 }], pricingMethod: 1 }
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 1001:
          return '待报价'
        case 1101:
          return '报价中'
        case 1201:
          return '已结束'
      }
    }

  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
/deep/ .inpBox .el-date-editor .el-input__inner {
    width: 150px;
}
.jiage{
  position: relative;
  .danwei1{
    position: absolute;
    right: 6px;
  }
}
.iconBox {
  position: absolute;
  right: -28px;
  top: 0;
  font-size: 20px;
  color: #0b25d6;
  z-index: 9999;
}
/deep/.el-textarea{
      width: 442px;
}
.hwlx /deep/.el-input__inner{
  width: 440px;

}
</style>
